import { formatDate } from "@its-engineering-and-development/ui-foundation/utils";
import type { UnspentChargeItem, UnspentView } from "./dashboard-types";
import { DashboardCard, DASHBOARD_SUMMARY_CARD_CLASS } from "./dashboard-card";
import { DashboardCardSelect } from "./dashboard-card-select";
import { DashboardListRow } from "./dashboard-list-row";
import { DashboardScrollableList } from "./dashboard-scrollable-list";

const UNSPENT_VIEW_OPTIONS = [
    { id: "user", label: "User" },
    { id: "department", label: "Department" },
    { id: "category", label: "Category" },
] as const;

export interface UnspentChargesCardProps {
    items: UnspentChargeItem[];
    view: UnspentView;
    onViewChange: (view: UnspentView) => void;
}

export function UnspentChargesCard({ items, view, onViewChange }: UnspentChargesCardProps) {
    return (
        <DashboardCard
            title="Unsubmitted charges"
            className={DASHBOARD_SUMMARY_CARD_CLASS}
            filter={
                <DashboardCardSelect
                    label="Unsubmitted charges grouping"
                    selectedKey={view}
                    options={[...UNSPENT_VIEW_OPTIONS]}
                    onSelectionChange={(key) => onViewChange(key as UnspentView)}
                />
            }
        >
            <DashboardScrollableList>
                <ul className="space-y-2">
                    {items.map((item) => (
                        <DashboardListRow key={item.id}>
                            <div className="flex size-10 shrink-0 items-center justify-center rounded-md bg-brand-solid text-sm font-semibold text-white">
                                {item.count}
                            </div>
                            <div className="min-w-0">
                                <p className="truncate text-sm font-semibold text-gray-900">{item.name}</p>
                                <p className="text-xs text-gray-500">Oldest charge: {formatDate(item.oldestChargeDate, "MM/dd/yyyy")}</p>
                            </div>
                        </DashboardListRow>
                    ))}
                </ul>
            </DashboardScrollableList>
        </DashboardCard>
    );
}
